export const SCHOOL_PITCH_VIDEO_IDS = {
  en: "d0PokstWnrY",
  ar: "2lo0ZQ7DbSo",
} as const;
